import { NoSsr } from '@mui/material'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

import { SplashScreen } from '@front/components/feedback'

import { Routes } from '../constants/routes'

const ToNotFound = () => {
  const router = useRouter()
  useEffect(() => {
    void router.push(Routes.NotFoundError)
  })
  return null
}

const NotFoundPage = (): JSX.Element => {
  return (
    <NoSsr fallback={<SplashScreen />}>
      <ToNotFound />
    </NoSsr>
  )
}

export default NotFoundPage
